
import { useMediaQuery } from 'react-responsive'
  export function ScreenType(){
      const isBigScreen = useMediaQuery({ query: '(min-device-width: 1152px)' })
      const isDesktopOrLaptop = useMediaQuery({ query: '(min-device-width: 1024x)' });
      const isTablet = useMediaQuery({ query: '(min-width: 768px)' });
      const isMobile= useMediaQuery({ query: '(min-width: 320px)' });
    
      const isTabletOrMobileDevice = useMediaQuery({query: '(max-device-width: 1223px)'})

    if(isBigScreen){
      return 'xl'
    }else if(isDesktopOrLaptop){
      return 'lg'
    }else if(isTablet){
      return 'md'
    }else if(isMobile){
      return 'sm'
    }
  }
 export function ScreenOriantation(){
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })
    return isPortrait ?  'portrait' : 'landscape';
  }


